import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import styles from './spinner.module.scss';
export const Spinner = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const className = classNames(styles.spinner, "spinner-icon");
    t0 = <div className={className} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};